export const LINE_STATES = {
  pendente: { label: "Pendente", badge: "bg-slate-100 text-slate-700 border-slate-200", strip: "bg-slate-400" },
  em_cotacao: { label: "Em Cotação", badge: "bg-amber-50 text-amber-800 border-amber-200", strip: "bg-amber-500" },
  aguarda_fornecedor: { label: "Aguarda Fornecedor", badge: "bg-cyan-50 text-cyan-800 border-cyan-200", strip: "bg-cyan-500" },
  aguarda_resposta: { label: "Aguarda Resposta", badge: "bg-violet-50 text-violet-800 border-violet-200", strip: "bg-violet-500" },
  aprovado: { label: "Aprovado", badge: "bg-emerald-50 text-emerald-800 border-emerald-200", strip: "bg-emerald-500" },
  em_transito: { label: "Em Trânsito", badge: "bg-blue-50 text-blue-800 border-blue-200", strip: "bg-blue-500" },
  recebido: { label: "Recebido", badge: "bg-teal-50 text-teal-800 border-teal-200", strip: "bg-teal-500" },
  faturado: { label: "Faturado", badge: "bg-indigo-50 text-indigo-800 border-indigo-200", strip: "bg-indigo-500" },
  entregue: { label: "Entregue", badge: "bg-slate-200 text-slate-800 border-slate-300", strip: "bg-slate-600" },
  cancelado: { label: "Cancelado", badge: "bg-rose-50 text-rose-800 border-rose-200", strip: "bg-rose-500" },
  devolvido: { label: "Devolvido · aguarda NC", badge: "bg-orange-50 text-orange-800 border-orange-200", strip: "bg-orange-500" },
  creditado: { label: "Creditado", badge: "bg-stone-100 text-stone-700 border-stone-300", strip: "bg-stone-500" },
  sem_resposta: { label: "Sem resposta", badge: "bg-zinc-100 text-zinc-600 border-zinc-300", strip: "bg-zinc-400" },
};

export const AT_STATES = {
  pendente: { label: "Pendente", strip: "bg-slate-400" },
  em_cotacao: { label: "Em Cotação", strip: "bg-amber-500" },
  aguarda_resposta: { label: "Aguarda resposta", strip: "bg-violet-500" },
  em_encomenda: { label: "Em encomenda", strip: "bg-sky-500" },
  recebido: { label: "Recebido", strip: "bg-teal-500" },
  faturado: { label: "Faturado", strip: "bg-emerald-600" },
  aprovado_parcial: { label: "Aprovado (parcial)", strip: "bg-emerald-500" },
  concluido: { label: "Concluído", strip: "bg-slate-600" },
  arquivado: { label: "Arquivado (sem resposta)", strip: "bg-zinc-400" },
};

export const TIPOS = {
  devolucao: { label: "Devolução", badge: "bg-orange-100 text-orange-800 border-orange-200", strip: "bg-orange-500" },
  garantia: { label: "Garantia", badge: "bg-purple-100 text-purple-800 border-purple-200", strip: "bg-purple-500" },
};

export const PRIORIDADES = {
  1: { label: "P1 · Alta", cls: "text-rose-600 font-semibold" },
  2: { label: "P2 · Média", cls: "text-amber-600 font-medium" },
  3: { label: "P3 · Normal", cls: "text-slate-500" },
};

export function tempoDesde(iso) {
  if (!iso) return "—";
  const diff = Date.now() - new Date(iso).getTime();
  const min = Math.floor(diff / 60000);
  if (min < 1) return "agora";
  if (min < 60) return `há ${min} min`;
  const h = Math.floor(min / 60);
  if (h < 24) return `há ${h}h`;
  const d = Math.floor(h / 24);
  return `há ${d}d`;
}

export const eur = (n) =>
  (n == null ? 0 : n).toLocaleString("pt-PT", { style: "currency", currency: "EUR" });


export const formatMatricula = (v) => {
  const clean = (v || "").toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 6);
  return (clean.match(/.{1,2}/g) || []).join("-");
};

export const numRef = (numero, codigo) => codigo || `#${numero}`;


export const fmtData = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("pt-PT", { day: "2-digit", month: "2-digit", year: "numeric" });
  } catch { return "—"; }
};

